// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6bd14963","488":"e7a425e2","732":"50cde7bf"}[chunkId] + ".chunk.js";
};